import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyBusinessPrioritiesChanges } from '../../api'
import { mapBusinessPriorityToApi } from '../../lib'
import { IBusinessPriorityForm } from '../types'

export const requestBusinessPrioritiesApplyChanges = createAsyncThunk(
  'businessPriorities/applyChanges',
  (form: IBusinessPriorityForm, { getState }) => {
    const fYear = selectJBPSettingsCurrentFYear(getState())
    const mappedForm = mapBusinessPriorityToApi(form, fYear)

    return applyBusinessPrioritiesChanges(mappedForm)
  }
)
